// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"NotificationsSection_titleWrapper__1yEwo","wrapper":"NotificationsSection_wrapper__2O9aG"};